import { ofType } from "redux-observable";
import { map, switchMapTo } from "rxjs/operators";
import { TypeActionApp } from "../app/actionApp";
import { actionNetworkConnected, actionNetworkDisconnected } from "./actionNetwork";
export var createEpicNetworkConnectivity = function (selectConnectionStatusStream) { return function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(selectConnectionStatusStream(deps)), map(function (val) {
        return val.status > 0 ? actionNetworkConnected(val.id) : actionNetworkDisconnected(val.id);
    }));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/createEpicNetworkConnectivity.ts
// module id = 2003
// module chunks = 3